import React, { Fragment, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import {
  Alert,
  Button,
  Col,
  Container,
  Fade,
  Form,
  FormGroup,
  Input,
  Row,
  Spinner,
} from "reactstrap";
import { register, getUsers, clear } from "../redux/actions/authActions";
import Footer from "./partials/Footer";
import Header from "./partials/Header";

const SignUp = (props) => {
  useEffect(() => {
    document.body.classList.add("img-bg");
    window.scrollTo(0, 0);
    dispatch(getUsers());
  }, []);
  const dispatch = useDispatch();
  const history = useHistory();
  let auth = useSelector((state) => state.auth);
  return (
    <Fragment>
      <Header {...props} background={false} login={false} />
      <div className="margin-top-fix xl text-white-1">
        <Container>
          <Row className="mb-5">
            <Col lg={6}>
              <div className="d-flex justify-content-center mt-5 pt-5 align-items-center">
                <div>
                  <h4>Get’s Started</h4>
                  <h5 className="mt-4">We are more than just a game.</h5>
                </div>
              </div>
            </Col>
            <Col lg={6} className="mt-5 mt-lg-0">
              <div className="form-wrapper">
                {auth.register && auth.register.code == 400 && (
                  <Fade
                    in={auth.register && auth.register.message}
                    onEnter={(e) =>
                      window.setTimeout(() => {
                        dispatch(clear("register"));
                      }, 5000)
                    }
                  >
                    <Alert
                      isOpen={auth.register && auth.register.message}
                      color="danger"
                    >
                      {auth.register && auth.register.message}
                    </Alert>
                  </Fade>
                )}
                {auth.register && auth.register.code == 201 && (
                  <Fade
                    in={auth.register && auth.register.message}
                    onEnter={(e) =>
                      window.setTimeout(() => {
                        dispatch(clear("register"));
                        history.push("/login");
                      }, 5000)
                    }
                  >
                    <Alert
                      isOpen={auth.register && auth.register.message}
                      color="success"
                    >
                      {auth.register && auth.register.message}
                    </Alert>
                  </Fade>
                )}
                <Form
                  onSubmit={(e) => {
                    e.preventDefault();
                    let registerObj = {
                      full_name: e.target.name.value,
                      email: e.target.email.value,
                      password: e.target.password.value,
                      my_games: [],
                      my_favourites: [],
                    };
                    console.log(registerObj);
                    dispatch(register(registerObj));
                  }}
                >
                  <FormGroup>
                    <Input
                      type="text"
                      placeholder="Name"
                      className="form-control"
                      name="name"
                      required
                    />
                  </FormGroup>
                  <FormGroup>
                    <Input
                      type="text"
                      placeholder="Email"
                      className="form-control mt-3"
                      name="email"
                      required
                    />
                  </FormGroup>
                  <FormGroup>
                    <Input
                      type="password"
                      placeholder="Password"
                      className="form-control mt-3"
                      name="password"
                      required
                      minLength={8}
                    />
                  </FormGroup>
                  <Button
                    block
                    type="submit"
                    disabled={auth.register == -1}
                    className="w-100 mt-3 bg-purple-1 border-0 py-4"
                    style={{ borderRadius: 24 }}
                  >
                    {auth.register == -1 ? <Spinner /> : "Sign Up"}
                  </Button>
                </Form>
                <small className="d-block mt-5 text-center">
                  Or Connect with
                </small>
                <div className="social-icons text-center mt-4">
                  <span className="facebook icon me-4">
                    <i className="fab fa-facebook-f"></i>
                  </span>
                  <span className="google icon me-4">
                    <i className="fab fa-google"></i>
                  </span>
                  <span className="twitter icon">
                    <i className="fab fa-twitter"></i>
                  </span>
                </div>
                <small className="d-block mt-5 text-center font-2 text-capitalize">
                  already have an account ?{" "}
                  <Link
                    to="/login"
                    className="text-red-1"
                    style={{ fontWeight: 700, textDecoration: "none" }}
                  >
                    Sign In
                  </Link>
                </small>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
      <br />
      <br />
      <br />
      <Footer></Footer>
    </Fragment>
  );
};

export default SignUp;
